export default __webpack_public_path__ + "static/thumb-4-e724ce85bf29be7bd4893bd710e6f483.jpg";